import React from "react";
import { Link } from "react-router-dom";


const Home = () => {
  return (
    <>
      {/* ----------------- Dark Blue Box ----------------- */}
      
      <div
  className="d-flex justify-content-start align-items-center px-3 px-lg-5 pb-4"
  style={{
    minHeight: "70vh",
    paddingTop: "120px",        // mobile
    backgroundColor: "#153555",
    color: "white",
  }}
>
        <div className="text-start">
          <h1
            className="fw-bold mb-4"
            style={{
              fontSize: "60px",
              fontWeight: "900",
              lineHeight: "1.2",
              textShadow: "1px 1px 2px rgba(0,0,0,0.3)"
            }}
          >
            Where Ideas Meet Execution
          </h1>

          <p
            className="text-start mb-5"
            style={{
              fontSize: "18px",
              color: "#cccccc",
              maxWidth: "600px",
            }}
          >
            We transform ambitious ideas into well-executed solutions that drive
            growth and success.
          </p>

          {/* Explore Projects Button */}
          <Link
            to="/projects"
            className="btn text-white fw-bold mt-4"
            style={{
              backgroundColor: "#FF8F1C",
              padding: "0.6rem 1.5rem",
              borderRadius: "5px",
              boxShadow: "0 4px 6px rgba(0,0,0,0.2)",
              transition: "all 0.3s ease",
            }}
            >
            Explore Our Projects <span className="ms-2">&rarr;</span>
          </Link>
        </div>
      </div>

      {/* ----------------- New Section Outside Box ----------------- */}
 <div className="container my-5">
  {/* Centered Heading & Subtext */}
  <div className="text-center mb-5">
    <h2
      className="fw-bold mb-3"
      style={{ fontSize: "35px", color: "#333333" , marginBottom: "10px",}} // neutral gray
    >
      Explore Our Core Services
    </h2>
    <p
      style={{
        fontSize: "14px",
        color: "#555555", // grey subtitle
        maxWidth: "650px",
        margin: "0 auto",
      }}
    >
      Smart solutions designed to grow your brand and simplify your journey.
    </p>
  </div>

  {/* Three Boxes */}
  <div className="row justify-content-center g-4">
    {/* Box 1 */}
    <div className="col-md-4">
      <div
        className="p-4 h-100"
        style={{
          backgroundColor: "white",
          borderRadius: "15px",
          textAlign: "center",
          boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
          border: "1px solid #cfd8e3",
        }}
      >
        <img
          src={require("../assets/images/product.png")}
          alt="Product Development"
          className="mb-3"
          style={{ height: "50px" }}
        />
        <h5 className="fw-bold mb-2" style={{ color: "#333333" }}>
          Product Development
        </h5>
        <p style={{ fontSize: "14px", color: "#555555" }}>
          Turn ideas into scalable digital products with precision and speed.
        </p>
      </div>
    </div>

    {/* Box 2 */}
    <div className="col-md-4">
      <div
        className="p-4 h-100"
        style={{
          backgroundColor: "white",
          borderRadius: "15px",
          textAlign: "center",
          boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
          border: "1px solid #cfd8e3",
        }}
      >
        <img
          src={require("../assets/images/smart.png")}
          alt="Smart Integrations"
          className="mb-3"
          style={{ height: "50px" }}
        />
        <h5 className="fw-bold mb-2" style={{ color: "#333333" }}>
          Smart Integrations
        </h5>
        <p style={{ fontSize: "14px", color: "#555555" }}>
          Connect systems and platforms seamlessly for smoother operations.
        </p>
      </div>
    </div>

    {/* Box 3 */}
    <div className="col-md-4">
      <div
        className="p-4 h-100"
        style={{
          backgroundColor: "white",
          borderRadius: "15px",
          textAlign: "center",
          boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
          border: "1px solid #cfd8e3",
        }}
      >
        <img
          src={require("../assets/images/growth.png")}
          alt="Growth & Innovation"
          className="mb-3"
          style={{ height: "50px" }}
        />
        <h5 className="fw-bold mb-2" style={{ color: "#333333" }}>
          Growth & Innovation
        </h5>
        <p style={{ fontSize: "14px", color: "#555555" }}>
          Drive business growth with creative thinking and smart technology.
        </p>
      </div>
    </div>
  </div>
</div>
    </>
  );
};

export default Home;